import { pageMeta } from "./meta.generated.js";

function isRecord(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

function localizedRaw(value, lang) {
  if (value === undefined || value === null) return "";
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value;
  if (isRecord(value)) {
    if (value[lang] !== undefined) return value[lang];
    if (value.en !== undefined) return value.en;
    if (value.de !== undefined) return value.de;
    const first = Object.values(value).find((entry) => entry !== undefined && entry !== null);
    return first ?? "";
  }
  return String(value);
}

function localizedText(value, lang) {
  const raw = localizedRaw(value, lang);
  if (Array.isArray(raw)) return raw.join(", ");
  return String(raw || "");
}

function setContent(selector, content) {
  const el = document.querySelector(selector);
  if (el && content) el.setAttribute("content", content);
}

function setHref(selector, href) {
  const el = document.querySelector(selector);
  if (el && href) el.setAttribute("href", href);
}

export function setMetaTags(lang, page = "home") {
  const meta = pageMeta[page] || pageMeta.home;
  if (!meta) return;

  const title = localizedText(meta.title, lang);
  const description = localizedText(meta.description, lang);
  const keywords = localizedText(meta.keywords, lang);
  const ogTitle = localizedText(meta.ogTitle, lang) || title;
  const ogDescription = localizedText(meta.ogDescription, lang) || description;
  const canonical = localizedText(meta.canonical, lang);
  const ogUrl = localizedText(meta.ogUrl, lang) || canonical;
  const ogImage = localizedText(meta.ogImage, lang);

  if (title) document.title = title;
  setContent('meta[name="description"]', description);
  setContent('meta[name="keywords"]', keywords);
  setContent('meta[property="og:title"]', ogTitle);
  setContent('meta[property="og:description"]', ogDescription);
  setContent('meta[property="og:locale"]', lang === "de" ? "de_DE" : "en_US");
  setContent('meta[property="og:url"]', ogUrl);
  setContent('meta[property="og:image"]', ogImage);
  setContent('meta[name="twitter:title"]', ogTitle);
  setContent('meta[name="twitter:description"]', ogDescription);
  setContent('meta[name="twitter:image"]', ogImage);
  setHref('link[rel="canonical"]', canonical);
}
